import React, { type ReactNode } from 'react';

/**
 * Ayarlar bölümlerinin ortak parçaları (Takvim, Yardım al): küçük gri bölüm
 * başlığı ve satırları çizgiyle ayrılan kart.
 */

export const SectionTitle: React.FC<{ children: ReactNode }> = ({ children }) => (
  <h2 className="text-sm font-medium text-muted-foreground">{children}</h2>
);

export const ListCard: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className="divide-y divide-border overflow-hidden rounded-xl border border-border bg-card text-card-foreground shadow-xs">
    {children}
  </div>
);

/** Başlık + açıklama solda, eylem düğmesi sağda. */
export const ActionRow: React.FC<{ title: string; description: string; action: ReactNode }> = ({
  title,
  description,
  action,
}) => (
  <div className="flex flex-wrap items-center justify-between gap-4 px-5 py-4">
    <div className="min-w-0 max-w-md space-y-1">
      <p className="text-sm font-medium leading-none">{title}</p>
      <p className="text-[0.8rem] leading-relaxed text-muted-foreground">{description}</p>
    </div>
    <div className="shrink-0">{action}</div>
  </div>
);
